<canvas class="w-full h-full" #signatureCanvas></canvas>
